<template>
    <div id="my-calculator">
        <vx-card class="calc-card" style="width: 400px;">
            <vs-input class="w-full result-box" v-model="result"></vs-input>
            <vs-row vs-w="12" class="calc-btn-list">
                <vs-col vs-w="4" v-for="num in 9" :key="num">
                    <vs-button class="calc-btn" :value="num">{{num}}</vs-button>
                </vs-col>
                <vs-col vs-w="4">
                    <vs-button class="calc-btn dot-btn">.</vs-button>
                </vs-col>
                <vs-col vs-w="4">
                    <vs-button class="calc-btn">0</vs-button>
                </vs-col>
                <vs-col vs-w="4">
                    <vs-button class="calc-btn backspace-btn">
                        <i class="material-icons backspace-icon">backspace</i>
                    </vs-button>
                </vs-col>

            </vs-row>
        </vx-card>
    </div>
</template>

<script>
export default {
    name: 'my-calculator',
    props: {
        titleOk: {
            type: String,
            default: 'Ok'
        },
        titleCancel: {
            type: String,
            default: 'Cancel'
        },
        position: {
            type: String,
            default: 'left'
        },
    },
    data() {
        return {
            result: ''
        }
    }
}
</script>

<style lang="scss">
    #my-calculator {
        .calc-card {
            // padding: 10px;
            .vx-card__body {
                padding: 0.5rem !important;
            }
            .result-box {
                .vs-input--input {
                    border-radius: 0 !important;
                    border-color: #ddd !important;
                    background: #fafafa;
                    text-align: center;
                    height: 60px;
                    border-top-left-radius: 8px !important;
                    border-top-right-radius: 8px !important;
                }
            }
            .calc-btn-list {
                border-right: 1px solid #ddd;
                // border-top: 1px solid #ccc;
                border-bottom-right-radius: 8px;
                .calc-btn {
                    height: 60px;
                    width: calc((400px - 1rem)/3);
                    border-radius: 0 !important; 
                    border-left: 1px solid #ddd;
                    border-bottom: 1px solid #ddd;
                    background-image: radial-gradient(circle, #ffffff, #fefefe, #fafafa, #f7f7f7, #eeeeee) !important;
                    color: #000;
                    font-size: 20px;
                }

                .dot-btn {
                    border-bottom-left-radius: 8px !important;
                }

                .backspace-btn {
                    border-bottom-right-radius: 8px !important;
                    padding-top: 0.9rem;
                    padding-bottom: 0.6rem;
                    .backspace-icon {
                        margin-left: -3px;
                        font-size: 20px;
                    }
                }

                .vs-button-filled {
                    &:hover {
                        box-shadow: unset !important;
                    }
                }
            }
        }
    }
</style>